export const experienceData = [
  {
    id: 1,
    company:
      "-Detected and masked Personally Identifiable Information (PII) for 60,000 records using custom Transformer resulting in savings of $50,000 for a quarter.",
    jobtitle: "Machine Learning Engineer Intern | Tech Mahindra",
    startYear: "Jun 2023",
    endYear: "Aug 2023",
  },
  {
    id: 2,
    company:
      "-Implemented Redux architecture in React app achieving 15% reduction in rendering time.Streamlined file uploads resulting in improved data management process.",
    jobtitle: "Software Engineer | Insta ICT Solutions",
    startYear: "Sep 2021",
    endYear: "Jul 2022",
  },
  {
    id: 3,
    company:
      "-Integrated PySpark and Azure Synapse to orchestrate efficient data transformations and visulaizations.Built scalable cloud infrastructure with ADF, ADLS, Databricks.",
    jobtitle: "Data Glove",
    startYear: "Dec 2020",
    endYear: "Mar 2021",
  },
];
